import { futureValueOfMonthlySavings } from "web_myplann/Goals/Helpers/futureValueOfMonthlySavings";
import { EARLY_FREEDOM_MAX_YEARS } from "web_myplann/Inspiration/EarlyFreedom/constants";
import { MONTHS_IN_YEAR } from "web_myplann/Shared/constants";

export const getEarlyFreedomYears = (
	monthlyContribution: number,
	yearlyRate: number,
	targetCapital: number,
): number | null => {
	if (targetCapital <= 0) return 0;
	if (monthlyContribution <= 0) return null;

	for (let years = 1; years <= EARLY_FREEDOM_MAX_YEARS; years++) {
		const savedCapital = futureValueOfMonthlySavings(
			monthlyContribution,
			yearlyRate,
			years * MONTHS_IN_YEAR,
		);
		if (savedCapital >= targetCapital) return years;
	}

	return null;
};
